import React, { ReactNode } from 'react'

import { Container } from '../../components/container/container.js'
import { Footer, FooterProps } from '../../components/footer/footer.js'
import { HeaderFlex, HeaderFlexProps } from '../../components/header-flex/header-flex.js'
import { Header, HeaderProps } from '../../components/header/header.js'
import { Hero, HeroProps } from '../../components/hero/hero.js'
import { Main } from '../../components/main/main.js'
import { NotificationList, NotificationListProps } from '../../components/notification-list/notification-list.js'

export interface ViewBaseProps {
    header: HeaderProps | HeaderFlexProps
    banner?: HeroProps
    children: ReactNode
    footer: FooterProps
    notifications?: NotificationListProps
}

export const ViewBase = (props: ViewBaseProps): JSX.Element => {
    const isFlexHeader = (header: HeaderProps | HeaderFlexProps): header is HeaderFlexProps =>
        (header as HeaderFlexProps).items !== undefined

    return (
        <>
            {isFlexHeader(props.header) ? <HeaderFlex {...props.header} /> : <Header {...props.header} />}
            <Main hasPadding={isFlexHeader(props.header)}>
                {props.banner && <Hero {...props.banner} />}
                <Container>{props.children}</Container>
            </Main>
            <Footer {...props.footer} />
            {props.notifications && <NotificationList {...props.notifications} />}
        </>
    )
}
